import FormattedText from './FormattedText'
import { renderTgTemplate, tgToPlain } from '../utils/tgFormat'

// Предпросмотр «как увидит агент в Telegram»: пузырь сообщения с тем же
// форматированием. Подстановки {name}, {geo} и т.п. заменяются примерами, чтобы
// было видно готовое сообщение, а не заготовку.

const SAMPLE_VALUES: Record<string, string> = {
    name: 'Анна',
    title: 'Анна',
    geo: 'India',
    source: 'Личные группы',
    telegram: '@example',
}

export default function TgMessagePreview({ value, withSamples = true }: { value: string; withSamples?: boolean }) {
    const html = withSamples ? renderTgTemplate(value, SAMPLE_VALUES) : value
    const empty = !tgToPlain(html).trim()
    return (
        <div className="tg-preview">
            <div className="tg-preview-title">Предпросмотр - так сообщение увидит получатель</div>
            <div className="tg-preview-chat">
                <div className="tg-preview-bubble">
                    {empty
                        ? <span className="tg-preview-empty">Здесь появится текст сообщения</span>
                        : <FormattedText html={html} />}
                    <span className="tg-preview-time">12:00 ✓✓</span>
                </div>
            </div>
            {withSamples && (
                <div className="tg-preview-hint">
                    Подстановки показаны примерами: {'{name}'} - Анна, {'{geo}'} - India.
                </div>
            )}
        </div>
    )
}
